import React, { useEffect, useState } from "react";
import axios from "axios";

const thStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  background: "#f3f3f3",
  textAlign: "center",
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "center",
};

function GrnSubmission() {
  // 🔹 Vendor + PO Code State
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [vendorCode, setVendorCode] = useState("");
  const [poCodes, setPoCodes] = useState([]);
  const [selectedPoId, setSelectedPoId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [poType, setPoType] = useState("");

  // 🔹 Download GRN State
  const [downloadPoCodes, setDownloadPoCodes] = useState([]);
  const [selectedDownloadPoId, setSelectedDownloadPoId] = useState("");

  // 🔹 Upload GRN State
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadMsg, setUploadMsg] = useState("");
  const [uploadLoading, setUploadLoading] = useState(false);

  // 🔹 Invoice State
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceFile, setInvoiceFile] = useState(null);
  const [invoiceMsg, setInvoiceMsg] = useState("");
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [selectedGrnFile, setSelectedGrnFile] = useState(null);

  // 🔹 Kit Conversion Popup State
  const [showMrpPopup, setShowMrpPopup] = useState(false);
  const [conversionRows, setConversionRows] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);

  // Fetch vendors on load
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api?type=vendors`)
      .then((res) => {
        // console.log("Vendors API Response:", res.data);
        setVendors(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => console.error("Error fetching vendors:", err));
  }, []);

  // Handle vendor change
  const handleVendorChange = (e) => {
    const companyName = e.target.value;
    setSelectedVendor(companyName);

    const vendor = vendors.find((v) => v.companyName === companyName);
    const code = vendor ? vendor.vendorCode : "";
 
    setVendorCode(code);
    fetchDownloadPoCodes(code);

    if (!code) {
      fetchDownloadPoCodes();
    }

    setSelectedPoId(null);
  };

  // Fetch PO codes by vendor
  const fetchPoCodes = async (vendorCode) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api?type=vendor&vendorCode=${vendorCode}`
      );
      const data = await response.json();
      console.log("fetchPoCodes response:", data);

      if (Array.isArray(data)) {
        setPoCodes(data);
      } else if (data && Array.isArray(data.poCodes)) {
        setPoCodes(data.poCodes);
      } else if (data && typeof data === "object") {
        setPoCodes(Object.values(data));
      } else {
        setPoCodes([]);
      }
    } catch (err) {
      console.error("Error fetching PO codes:", err);
      setPoCodes([]);
    }
    setLoading(false);
  };

  // Handle GRN download
  const handleDownload = async () => {
    if (!selectedDownloadPoId) {
      alert("Please select a PO code before downloading.");
      return;
    }

    if (loading) return;

    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api?type=download-grn&poId=${selectedDownloadPoId}`
      );

      if (!response.ok) throw new Error("Failed to download GRN sheet");

      const disposition = response.headers.get("Content-Disposition");
      
      console.log("Content-Disposition:", disposition);

      let fileName = `GRN-${selectedDownloadPoId}.xlsx`;

      if (disposition && disposition.includes("filename=")) {
        fileName = disposition
          .split("filename=")[1]
          .replace(/"/g, "")
          .trim();
      }

      console.log("Final filename:", fileName);

      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("GRN Download Error:", err);
      alert("Failed to download GRN: " + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Handle GRN upload
  const handleUploadGrn = async () => {
    if (!uploadFile) {
      setUploadMsg("Please select a file to upload.");
      return;
    }

    if (!selectedDownloadPoId && !selectedPoId) {
      setUploadMsg("Please select a PO Code before uploading GRN.");
      return;
    }

    setUploadLoading(true);
    setUploadMsg("");

    try {
      const formData = new FormData();
      formData.append("grnFile", uploadFile);
      formData.append("poId", selectedDownloadPoId || selectedPoId);
      formData.append("invoiceNumber", invoiceNumber || null);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/post/upload-grn`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      // Kit Mrp Conversion
      if (data.requiresMrpConfirmation) {
        const updatedRows = data.conversions.map((row) => ({
          ...row,
          finalChildMrp: row.suggestedChildMrp,
        }));

        setConversionRows(updatedRows);
        setShowMrpPopup(true);
        setUploadMsg("");

        setUploadLoading(false);

        return;
      }

      if (!response.ok)
        throw new Error(data.message || "Failed to upload GRN sheet");

      let msg = `✅ Success: ${data.message} (${data.updatedRows} rows updated)`;

      if (Array.isArray(data.skippedSkus) && data.skippedSkus.length > 0) {
        msg += `\n\nSkipped SKUs:\n- ${data.skippedSkus.join("\n- ")}`;
      }

      setUploadMsg(msg);
      setUploadFile(null);
      document.getElementById("uploadInput").value = "";
    } catch (err) {
      setUploadMsg(`❌ Error: ${err.message}`);
    } finally {
      setUploadLoading(false);
    }
  };

  // Handle Child MRP Convertion
  const handleConfirmMrp = async () => {
    try {
      setConfirmLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/post/confirm-kit-mrp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            conversions: conversionRows,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to confirm MRP");
      }

      setUploadMsg(`✅ Success: ${data.message} (${data.updatedRows} rows updated)`);
      setShowMrpPopup(false);
      setConversionRows([]);
      setUploadFile(null);
      document.getElementById("uploadInput").value = "";

    } catch (err) {
      setUploadMsg(`❌ Error: ${err.message}`);
    } finally {
      setConfirmLoading(false);
    }
  };

  const fetchDownloadPoCodes = async (vendorCode = "") => {
    try {
      let url =
        `${process.env.REACT_APP_API_URL}/api?type=po-codes`;

      if (vendorCode) {
        url += `&vendorCode=${vendorCode}`;
      }

      const response = await fetch(url);
      const data = await response.json();

      setDownloadPoCodes(
        Array.isArray(data) ? data : []
      );
    } catch (err) {
      console.error(err);
      setDownloadPoCodes([]);
    }
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setInvoiceDate(today);
  }, []);

  // Fetch PO Type when selected PO changes
  useEffect(() => {
    const poId = selectedDownloadPoId;

    if (!poId) {
      setPoType("");
      return;
    }

    fetch(
      `${process.env.REACT_APP_API_URL}/api?type=get-po-info&poId=${poId}`
    )
      .then((res) => res.json())
      .then((data) => {
        setPoType(data.poType || "");
      })
      .catch(() => {
        setPoType("");
      });
  }, [selectedDownloadPoId]);

  // Handle Invoice Submission (with GRN + reset date correctly)
  const handleInvoiceSubmit = async () => {
    const poIdToUse = selectedPoId || selectedDownloadPoId;

    if (
      !invoiceFile ||
      !invoiceDate ||
      !poIdToUse ||
      !selectedVendor ||
      !vendorCode ||
      !selectedGrnFile
    ) {
      setInvoiceMsg(
        "Please select Vendor, Vendor Code, PO Code, Invoice Date, GRN File and Invoice File."
      );
      return;
    }

    setInvoiceLoading(true);
    setInvoiceMsg("");

    try {
      const formData = new FormData();
      formData.append("grnFile", selectedGrnFile);
      formData.append("invoiceFile", invoiceFile);
      formData.append("invoiceDate", invoiceDate);
      formData.append("vendor", selectedVendor);
      formData.append("vendorCode", vendorCode);
      formData.append("poId", poIdToUse );

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/post/upload-invoice`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      // Check Duplicate Invoice Submission
      if (
        response.status === 400 &&
        data.message.includes("already submitted")
      ) {
        setInvoiceMsg(`
    <div 
      style="
        margin-top:20px;
        background:#424141; 
        padding:20px; 
        color:#fff; 
        border-radius:10px;
        text-align:center;
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        font-size:16px;
        line-height:1.5;
      "
    >
      <strong>❌ Invoice Already Submitted</strong>
      ${data.message}
    </div>
  `);
        return;
      }

      if (!response.ok)
        throw new Error(data.message || "Failed to send invoice");

      // Detailed message
      const formattedReminderDate = new Date(data.reminderDate).toLocaleString(
        "en-IN",
        {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }
      );

      setInvoiceMsg(`
        <div style="
          background:#424141;
          color:#f8f8f8;
          border-radius:10px;
          padding:15px;
          text-align:left;
          font-size:16px;
          margin:15px auto;
        ">
          ✅ <strong>Success:</strong> ${data.message}<br />
          🏷️ <strong>PO Code:</strong> ${data.poCode}<br />
          ${
            data.poType === "LSL" && data.invoiceNumber
              ? `📄 <strong>Invoice Number:</strong> ${data.invoiceNumber}<br />`
              : ""
          }
          🏢 <strong>Vendor:</strong> ${selectedVendor}<br />
          ⏳ <strong>Reminder Days:</strong> ${data.reminderDays}<br />
          📅 <strong>Reminder scheduled for:</strong> ${formattedReminderDate}
        </div>
      `);

      // Reset fields
      setSelectedGrnFile(null);
      setInvoiceFile("");
      setInvoiceDate(new Date().toISOString().split("T")[0]);
      setSelectedVendor("");
      setVendorCode("");
      setSelectedPoId("");
      setSelectedDownloadPoId("");
      document.getElementById("invoiceInput").value = "";
    } catch (err) {
      setInvoiceMsg(`❌ Error: ${err.message}`);
    } finally {
      setInvoiceLoading(false);
    }
  };

  return (
    <>
      <div className="grn-submission-form">
        <div className="form-container" style={{ padding: "20px" }}>
          {/* Vendor Selection */}
          <div
            style={{
              display: "inline-flex",
              gap: "20px",
              alignItems: "center",
              width: "100%",
            }}
          >
            <label>
              <h3>Vendor Name:</h3>
              <select
                className="large-input"
                value={selectedVendor}
                onChange={handleVendorChange}
              >
                <option value="">-- Choose Vendor --</option>
                {vendors.map((vendor, index) => (
                  <option key={index} value={vendor.companyName}>
                    {vendor.companyName}
                  </option>
                ))}
              </select>
            </label>
            <label>
              <h3>Vendor Code:</h3>
              <input
                placeholder="-- Vendor Code --"
                className="vendor-input large-input"
                type="text"
                value={vendorCode}
                readOnly
              />
            </label>
          </div>

          <br />

          {/* Download GRN */}
          <div
            style={{
              display: "inline-flex",
              gap: "20px",
              alignItems: "center",
              width: "100%",
            }}
          >
            <select
              className="large-input"
              value={selectedDownloadPoId}
              onChange={(e) => setSelectedDownloadPoId(Number(e.target.value))}
              disabled={downloadPoCodes.length === 0 || loading}
              
            >
              <option value="">-- Select PO Code --</option>
              {downloadPoCodes.map((po) => (
                <option key={po.id} value={po.id}>
                  {po.displayPo}
                </option> 
              ))}
            </select>
            <label style={{
                display: 'flex', 
                gap: '20px', 
                alignItems: 'center',
                width: '50%',
                }}
              > 
              <input
                placeholder="-- PO Type --"
                className="po-type-input"
                type="text"
                value={poType}
                readOnly
                style={{ maxWidth: "34%",}}
              />
          
            <button
              onClick={handleDownload}
              disabled={loading || !selectedDownloadPoId}
              style={{ maxWidth: "51%" }}
            >
              {loading ? "Downloading..." : "Download GRN Sheet"}
            </button>
            </label>
          </div>

          <br />

          {/* Upload GRN */}
          <div
            style={{
              display: "inline-flex",
              gap: "20px",
              alignItems: "center",
              width: "100%",
            }}
          >
            <input
              id="uploadInput"
              type="file"
              accept=".xlsx,.xls"
              onChange={(e) => setUploadFile(e.target.files[0])}
              disabled={uploadLoading}
            />
              <input
                type="text"
                placeholder="Invoice Number"
                value={invoiceNumber}
                required
                onChange={(e) => setInvoiceNumber(e.target.value)}
                className="invoice-number-input"
              />
            <button
              onClick={handleUploadGrn}
              disabled={uploadLoading || !uploadFile}
            >
              {uploadLoading ? "Uploading..." : "Upload GRN"}
            </button>
          </div>
          {/* {uploadMsg && <p>{uploadMsg}</p>} */}
          <div style={{ display: "flex" }}>
            {uploadMsg && (
              <div className="grn-message-row">
                <p
                  className={
                    uploadMsg.includes("Success") ? "success-msg" : "error-msg"
                  }
                >
                  {uploadMsg}
                </p>
              </div>
            )}
          </div>

          {/* Submit Invoice */}
          <div>
            <div
              style={{
                display: "flex",
                gap: 20,
                alignItems: "center",
                color: "#1c1c1c",
              }}
            >
              <input
                style={{ width: "20%", color: "#1c1c1c", caretColor: "#1c1c1c" }}
                type="date"
                value={invoiceDate}
                onChange={(e) => setInvoiceDate(e.target.value)}
                required
              />

              {/* <div className="file-upload-field">
          <label htmlFor="invoiceFile">Invoice File</label> */}
              <input
                style={{ width: "30%" }}
                type="file"
                accept=".xlsx,.xls"
                onChange={(e) => setSelectedGrnFile(e.target.files[0])}
              />
              {/* </div> */}

              {/* <div className="file-upload-field">
            <label htmlFor="grnFile">GRN File</label> */}
              <input
                style={{ width: "30%" }}
                placeholder=""
                id="invoiceInput"
                type="file"
                accept=".pdf,.docx,.xlsx,.xls"
                onChange={(e) => setInvoiceFile(e.target.files[0])}
              />
              {/* </div> */}

              <button
                style={{ width: "20%", height: "45px" }}
                onClick={handleInvoiceSubmit}
                disabled={invoiceLoading}
              >
                {invoiceLoading ? "Submitting..." : "Submit Invoice"}
              </button>
            </div>
            {invoiceMsg && (
              <div dangerouslySetInnerHTML={{ __html: invoiceMsg }} />
            )}
          </div>
        </div>
      </div>

      {showMrpPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "25px",
              borderRadius: "10px",
              width: "90%",
              maxWidth: "1200px",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >

            <h2 style={{ marginBottom: "20px" }}>
              Confirm Child SKU MRP
            </h2>

            <div
              style={{
                display: "flex",
                gap: "20px",
                marginBottom: "20px",
                flexWrap: "wrap",
              }}
            >

              <div
                style={{
                  background: "#fff7ed",
                  padding: "12px 18px",
                  borderRadius: "8px",
                  border: "1px solid #fdba74",
                  fontWeight: "600",
                  color: "#9a3412",
                }}
              >
                Parent Retained:
                {" "}
                {
                  conversionRows.reduce(
                    (sum, r) =>
                      sum + Number(r.parentRetainedQty || 0),
                    0
                  )
                }
              </div>

              <div
                style={{
                  background: "#eff6ff",
                  padding: "12px 18px",
                  borderRadius: "8px",
                  border: "1px solid #93c5fd",
                  fontWeight: "600",
                  color: "#1d4ed8",
                }}
              >
                Conversion Qty:
                {" "}
                {
                  conversionRows.reduce(
                    (sum, r) =>
                      sum + Number(r.conversionBaseQty || 0),
                    0
                  )
                }
              </div>

              <div
                style={{
                  background: "#f0fdf4",
                  padding: "12px 18px",
                  borderRadius: "8px",
                  border: "1px solid #86efac",
                  fontWeight: "600",
                  color: "#15803d",
                }}
              >
                Final Child Qty:
                {" "}
                {
                  conversionRows.reduce(
                    (sum, r) =>
                      sum + Number(r.convertedQty || 0),
                    0
                  )
                }
              </div>

            </div>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr>
                  <th style={thStyle}>S.N.</th>
                  <th style={thStyle}>Parent SKU</th>
                  <th style={thStyle}>Child SKU</th>
                  <th style={thStyle}>Parent Qty</th>
                  <th style={thStyle}>Retained Parent Qty</th>
                  <th style={thStyle}>Conversion Qty</th>
                  <th style={thStyle}>Multiplier</th>
                  <th style={thStyle}>Converted Qty</th>
                  <th style={thStyle}>Parent MRP</th>
                  <th style={thStyle}>Suggested Child MRP</th>
                  <th style={thStyle}>Final Child MRP</th>
                </tr>
              </thead>

              <tbody>

                {conversionRows.map((row, index) => (

                  <tr key={index}>

                    <td style={tdStyle}>
                      {index + 1}
                    </td>

                    <td style={tdStyle}>
                      {row.parentSkuCode}
                    </td>

                    <td style={tdStyle}>
                      {row.childSkuCode}
                    </td>

                    <td style={tdStyle}>
                      {row.parentQty}
                    </td>

                    <td
                      style={{
                        ...tdStyle,
                        color: "#d97706",
                        fontWeight: "700",
                      }}
                    >
                      {row.parentRetainedQty}
                    </td>

                    <td
                      style={{
                        ...tdStyle,
                        color: "#2563eb",
                        fontWeight: "700",
                      }}
                    >
                      {row.conversionBaseQty}
                    </td>

                    <td style={tdStyle}>
                      x{row.multiplier}
                    </td>

                    <td
                      style={{
                        ...tdStyle,
                        color: "#16a34a",
                        fontWeight: "700",
                      }}
                    >
                      {row.convertedQty}
                    </td>

                    <td style={tdStyle}>
                      ₹{row.parentMrp}
                    </td>

                    <td style={tdStyle}>
                      ₹{row.suggestedChildMrp}
                    </td>

                    <td style={tdStyle}>

                      <input
                        type="number"
                        value={row.finalChildMrp}

                        onChange={(e) => {

                          const updated = [...conversionRows];

                          updated[index].finalChildMrp =
                            Number(e.target.value);

                          setConversionRows(updated);
                        }}

                        style={{
                          width: "120px",
                          padding: "8px",
                        }}
                      />

                    </td>

                  </tr>
                ))}

              </tbody>
            </table>

            <div
              style={{
                marginTop: "20px",
                marginBottom: "30px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >

              <button
                onClick={() => {
                  setShowMrpPopup(false);
                }}
              >
                Cancel
              </button>

              <button
                onClick={handleConfirmMrp}
                disabled={confirmLoading}
              >
                {confirmLoading
                  ? "Saving..."
                  : "Confirm & Process GRN"}
              </button>

            </div>

            <p
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "-15px",
                color: "#64748b",
                fontSize: "14px",
              }}
            >
              For kit SKUs above 24 qty,
              10% stock will remain in parent SKU inventory
              and remaining 90% will convert into child SKU inventory.
            </p>

          </div>
        </div>
      )}
    </>
  );
}

export default GrnSubmission;
